import { render, staticRenderFns } from "./videoAccount.vue?vue&type=template&id=1031336f&scoped=true&"
import script from "./videoAccount.vue?vue&type=script&lang=js&"
export * from "./videoAccount.vue?vue&type=script&lang=js&"
import style0 from "./videoAccount.vue?vue&type=style&index=0&id=1031336f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1031336f",
  null
  
)

export default component.exports